import React from 'react';
import backgroundImage from '../assets/other/01.png';

export const Background: React.FC = () => {
  return (
    <img
      src={backgroundImage}
      alt='SignIn'
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        inset: 0,
        zIndex: -1,
      }}
    />
  );
};
